import {DefaultValueConstant} from "./Question";
import moment from 'moment';
import store from "../store";
import DatePickerQuestion from '@/components/DatePickerQuestion.vue';

export default class Choice {

    constructor(public id: number, public label: string, public code: string, public description = '') {
        if (Object.values(DefaultValueConstant).includes(label)) {
            this.label = this.getConstantValue(label);
            if(moment.isMoment(this.label)){
                this.label = this.label.format(DatePickerQuestion.displayFormat);
            }
        }
        if (Object.values(DefaultValueConstant).includes(code)) {
            this.code = this.getConstantValue(code);
            if(moment.isMoment(this.code)){
                this.code = this.code.format('DD/MM/YYYY');
            }
        }
    }

    private getConstantValue(constant: DefaultValueConstant) {
        switch (constant) {
            case DefaultValueConstant.CurrentBranch: {
                return store.state.currentResponseGroup.branch.id;
            }
            case DefaultValueConstant.Now: {
                return moment(new Date()).format(DatePickerQuestion.displayFormat);
            }
            case DefaultValueConstant.Tomorrow: {
                const tomorrow = moment(new Date()).add(1, 'days');
                return tomorrow.format(DatePickerQuestion.displayFormat);
            }
            case DefaultValueConstant.FirstDayOfCurrentMonth:
            case DefaultValueConstant.FDOCM: {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                var firstDay = new Date(y, m, 1);

                // console.log(firstDay);
                const firstDayOfCurrentMonth = moment(firstDay);
                // console.log(firstDayOfCurrentMonth);
                // return firstDay;
                return firstDayOfCurrentMonth;
            }
            case DefaultValueConstant.FirstDayOfNextMonth:
            case DefaultValueConstant.FDONM: {
                var now = new Date();
                // return now;
                if (now.getMonth() == 11) {
                    var current = moment(new Date(now.getFullYear() + 1, 0, 1));
                } else {
                    var current = moment(new Date(now.getFullYear(), now.getMonth() + 1, 1));
                }
                return current;
            }
            default: {
                return constant;
            }
        }
    }
}
